import * as ExcessUtil from 'notebook/tables/excess/Util';
import {QueryResolution, ResolutionQueryType} from 'notebook/tables/TableStoreTransforms';

import {
  CustomResolutionQuery,
  StringResolutionQuery,
  StringResolutionType,
} from './StringResolutionConstants';

type ParsedResolutionQuery = StringResolutionQuery | CustomResolutionQuery;

// Matches the not-found errors built in benchling/notebook/tables/resolve_strings_to_values.py. The server
// sends only the message, so it is the only way to tell not-found apart from multiple-matches errors.
const NOT_FOUND_ERROR_PATTERN = /^No .+ found matching /;

function isRetryableStringQuery(query: ParsedResolutionQuery): query is StringResolutionQuery {
  if (query.type !== ResolutionQueryType.STRING) {
    return false;
  }
  switch (query.valueType.type) {
    case StringResolutionType.BIOENTITY:
    case StringResolutionType.BATCH:
    case StringResolutionType.STORABLE:
    case StringResolutionType.ENTRY:
      return true;
    default:
      return false;
  }
}

export function isRetryableFailedResolution(resolution: QueryResolution): boolean {
  if (!isRetryableStringQuery(resolution.query)) {
    return false;
  }
  return (
    resolution.error?.type === ExcessUtil.ValueError.type &&
    NOT_FOUND_ERROR_PATTERN.test(resolution.error.message)
  );
}
